import './App.css';
import Hero from './components/Hero';
import Loader from './components/Loader';
import React, { useEffect, useState } from 'react'; // Mueve React al principio
import Contacto from './components/Contacto';

function App() {
  const [loading, setLoading] = useState(true);

  // Simula una carga inicial o espera una llamada a datos
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false); // Cambia a falso cuando los datos estén listos
    }, 2000); // Simulación de carga de 2 segundos

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="h-screen w-screen flex items-center justify-center relative scroll-container">
      <Hero />
      {loading && (
        <div className="absolute z-[100] inset-0 flex items-center justify-center bg-black">
          <Loader />
        </div>
      )}
    </div>
  );
}

export default App;
